import React from 'react';
import 'pages/Home/components/About/About.css';
import DogCard from 'components/DogCard/DogCard';
import useAboutDogsData from 'pages/Home/components/About/hooks/useAboutDogsData';

function About() {
    const [dogsData] = useAboutDogsData();
    return (
        <section className={'about-dog'}>
            <h2 className={'article__title'}>OUR ADULTS DOGS </h2>

            <div className={'about-dog-cards '}>
                {dogsData?.docs?.map(dogRef => (
                    <DogCard dogRef={dogRef} id={dogRef.id} key={dogRef.id} />
                ))}
            </div>
        </section>
    );
}

export default About;
